export const PAGE_SIZES = [12, 24, 36];